/**
 * Account Redirect Utilities
 *
 * Centralizes locale-safe redirect URL resolution for account flows.
 */

function getAccountData() {
    return (typeof window !== 'undefined' && window.accountData) ? window.accountData : {};
}

function joinPath(baseUrl, path) {
    const base = (typeof baseUrl === 'string' && baseUrl.trim() !== '') ? baseUrl.trim() : '/';
    const cleanPath = (path || '').replace(/^\/+/, '');

    if (base.endsWith('/')) {
        return `${base}${cleanPath}`;
    }

    return `${base}/${cleanPath}`;
}

function getLocalizedHomeUrl() {
    const data = getAccountData();
    if (typeof data.homeUrl === 'string' && data.homeUrl.trim() !== '') {
        return data.homeUrl;
    }

    return '/';
}

export function getHomeRedirectUrl() {
    return getLocalizedHomeUrl();
}

export function getCasinoRedirectUrl() {
    const data = getAccountData();

    if (typeof data.casinoUrl === 'string' && data.casinoUrl.trim() !== '') {
        return data.casinoUrl;
    }

    return joinPath(getLocalizedHomeUrl(), 'casino/');
}

export function getWalletRedirectUrl() {
    const data = getAccountData();

    if (typeof data.walletUrl === 'string' && data.walletUrl.trim() !== '') {
        return data.walletUrl;
    }

    return joinPath(getLocalizedHomeUrl(), 'your-account/my-wallet/');
}
